import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import {
  SUPPORT_SET,
  SUPPORT_SET_LOADING,
  useSupportDispatch,
  useSupport,
} from "../SupportContext";

export function useFetchSupportArticles() {
  const dispatch = useSupportDispatch();

  const { articles } = useSupport();

  const { data } = useQuery({
    queryKey: ["support-articles"],
    queryFn: () => apiRequest("/api/fetch-support-data/", "GET", null, false),
    enabled: !articles?.length,
  });

  useEffect(() => {
    dispatch({
      type: SUPPORT_SET_LOADING,
      payload: { isLoading: true },
    });

    if (data) {
      dispatch({
        type: SUPPORT_SET,
        payload: {
          articles: data.allArticles,
          categories: data.categories,
        },
      });
    }
  }, [data]);
}

export default useFetchSupportArticles;
